import React from "react";
import { WizardProps } from "./types";
import WizardFooter from "./WizardFooter";

const Wizard: React.FC<WizardProps> = ({
  steps,
  stepCurrent,
  onNextStep,
  onBackStep,
  onFinish,
  isLoading,
  isReadOnly,
}) => {
  const hasFooter = stepCurrent !== undefined && onNextStep && onBackStep && onFinish;

  return (
    <>
      {steps}
      {hasFooter && (
        <WizardFooter
          stepCurrent={stepCurrent!}
          steps={steps}
          onNextStep={onNextStep!}
          onBackStep={onBackStep!}
          onFinish={onFinish!}
          isLoading={isLoading ?? false}
          isReadOnly={isReadOnly ?? false}
        />
      )}
    </>
  );
};

export default Wizard;
